import React, { useState, useEffect } from "react";

const CheckboxOrderForm = (props) => {
    const {
        options = [
            "早く避難できると思ったから",
            "安全だと思ったから",
            "エレベーターやエスカレーターは避難に使えないから",
            "階段以外の選択肢がないから",
            "従業員の指示に従った [icon:exit]",
        ],
        fixedOptions = [],
        maxChecks = 1,
        onOptionSelect = () => {},
        setNumberOfSelectedOptions = () => {},
        shuffle = false,
        name = "reasons",
    } = props;

    const [checkedOrder, setCheckedOrder] = useState([]);
    const [shuffledOptions, setShuffledOptions] = useState([]);

    // アイコンマップ
    const iconMap = {
        exit: `${process.env.PUBLIC_URL}/images/icon-exit.svg`,
    };

    // 表示用
    const renderWithIcons = (text) => {
        const parts = text.split(/(\[icon:[a-zA-Z0-9_-]+\])/);
        return parts.map((part, i) => {
            const match = part.match(/\[icon:([a-zA-Z0-9_-]+)\]/);
            if (match) {
                const iconKey = match[1];
                const src = iconMap[iconKey];
                if (src) {
                    return <img key={i} src={src} alt={iconKey} className="inline-icon" />;
                }
            }
            return <span key={i}>{part}</span>;
        });
    };

    // 送信用
    const stripIconTags = (text) => {
        return text.replace(/\[icon:[a-zA-Z0-9_-]+\]/g, "").trim();
    };

    const arrayShuffle = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const r = Math.floor(Math.random() * (i + 1));
            [array[i], array[r]] = [array[r], array[i]];
        }
        return array;
    };

    useEffect(() => {
        const newArray = shuffle ? arrayShuffle([...options]) : [...options];
        setShuffledOptions(newArray);
    }, [options, shuffle]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        setCheckedOrder((prevOrder) => {
            let newOrder;
            if (checked) {
                if (prevOrder.length < maxChecks) {
                    newOrder = [...prevOrder, value];
                } else {
                    newOrder = [...prevOrder.slice(1), value];
                }
            } else {
                newOrder = prevOrder.filter((item) => item !== value);
            }
            return newOrder;
        });
    };

    useEffect(() => {
        onOptionSelect(checkedOrder.length > 0);
        setNumberOfSelectedOptions(checkedOrder.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedOrder]);

    const allOptions = [...shuffledOptions, ...fixedOptions];

    const reasonBinaryInputs = allOptions.map((label, index) => {
        const cleanValue = stripIconTags(label);
        const isChecked = checkedOrder.includes(cleanValue);
        return (
            <input
                key={index}
                type="hidden"
                name={`${name}-reason-${index + 1}`}
                value={isChecked ? "1" : "0"}
            />
        );
    });

    return (
        <div className="reasons-selector-container">
            <div
                className={`reasons-selector ${
                    checkedOrder.length === maxChecks ? "reasons-selector--max-selected" : ""
                }`}
            >
                {allOptions.map((label) => {
                    const cleanValue = stripIconTags(label);
                    const orderIndex = checkedOrder.indexOf(cleanValue);
                    const isChecked = checkedOrder.includes(cleanValue);
                    return (
                        <label
                            key={label}
                            className="reasons-selector__item"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    const fakeEvent = {
                                        target: { value: cleanValue, checked: !isChecked },
                                    };
                                    handleCheckboxChange(fakeEvent);
                                }
                            }}
                        >
                            <input
                                type="checkbox"
                                value={cleanValue}
                                onChange={handleCheckboxChange}
                                checked={isChecked}
                            />
                            <span className="reasons-selector__item-check">
                                <span className="reasons-selector__item-number">
                                    {orderIndex >= 0 ? orderIndex + 1 : ""}
                                </span>
                            </span>
                            <span className="reasons-selector__item-label">
                                {renderWithIcons(label)}
                            </span>
                        </label>
                    );
                })}
            </div>

            {/* 選択順序を送信 */}
            <div id="hidden-inputs">
                {reasonBinaryInputs}
            </div>
        </div>
    );
};

export default CheckboxOrderForm;
